<template>
  <div class='BuildIcon5'>
    <svg version="1.1" id="Uploaded to svgrepo.com" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="tam" :height="tam" viewBox="0 0 32 32" xml:space="preserve">
       <path :fill="color" class="sharpcorners_een" d="M20,12H4V6h16V12z M21,6v6h7V6H21z M4,26h16v-6H4V26z M21,26h7v-6h-7V26z M12,19h16v-6H12V19z M11,13H4v6h7V13z"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'BuildIcon5',
  props: {
    tam: {
      type: String,
      default: '22px'
    },
    color: {
      type: String,
      default: '#000000'
    }
  }
}
</script>

<style scoped>
.BuildIcon5 {
}
</style>
